/**
 * Engraving toggle — black-framed panel (chip + textarea) matching seal /
 * two-tone treatment. Thinkspace checkbox is mislabelled data-option="Two-tone".
 *
 * Depends on: sj-3d-builder.js, sj-image-stepper.css, sj-metal-chips.css
 */
(function () {
  'use strict';

  var B = window.Sj3dBuilder;
  if (!B) return;

  var READY = 'data-sj-engraving-chip-ready';
  var HOST = 'sj-engraving-host';
  var PANEL = 'sj-engraving-panel';
  var hostWidget = null;
  var waived = false;
  var codeStatus = '';
  var codeTicket = 0;

  /**
   * Waiver check. The page only has these hashes, not the codes.
   * To add or change one, replace a hex. From any folder:
   *   node -e "const c=require('crypto');console.log(c.createHash('sha256').update(String(process.argv[1]).trim().toUpperCase()).digest('hex'))" "New Code Here"
   */
  var WAIVER_SHA256 = [
    '5d6f8760bc0c738ddbaf3c36d8add8ad253e50c847422c6f5a840f2c73c040ef',
    'fc05455f9acd09eb2578527f65554b93e517d74dfe8ffaf79dbd996773b87291',
  ];

  function isEngravingField(field) {
    var label = field && field.querySelector('label');
    var text = String(
      (label && label.textContent) || (field && field.textContent) || ''
    ).toLowerCase();
    return text.includes('engrav');
  }

  function findEngravingFields() {
    return Array.prototype.filter.call(
      document.querySelectorAll('[data-option="Two-tone"]'),
      isEngravingField
    );
  }

  function getCheckbox(field) {
    return field ? field.querySelector('input[type="checkbox"]') : null;
  }

  /** Outer Thinkspace grid that holds the toggle + textarea. */
  function getPanel(field) {
    var wrap = field && field.parentElement;
    return wrap && wrap.parentElement ? wrap.parentElement : null;
  }

  function getTextarea(panel) {
    return panel ? panel.querySelector('textarea') : null;
  }

  function getInputWrapper(panel) {
    if (!panel) return null;
    return (
      panel.querySelector('.contact-form__input-wrapper') ||
      (getTextarea(panel) && getTextarea(panel).parentElement) ||
      null
    );
  }

  function linesUsed(textarea) {
    if (!textarea) return 0;
    return String(textarea.value || '')
      .split('\n')
      .filter(Boolean).length;
  }

  function priceLabel(field) {
    var label = field && field.querySelector('label');
    var text = String((label && label.textContent) || '');
    var live = text.match(/\+\s*\$?\s*[\d,]+(?:\.\d{2})?/);
    if (live) return live[0].replace(/\s+/g, '');
    try {
      var data =
        (B && typeof B.catalogData === 'function' && B.catalogData()) || null;
      var raw = data && data.addons_pricing && data.addons_pricing.engraving;
      var n = Number(raw);
      if (Number.isFinite(n) && n > 0) {
        return '+$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
      }
    } catch (_) {
      /* ignore */
    }
    return '';
  }

  function ensureMount(field) {
    var mount = field.querySelector('[data-sj-engraving-chip]');
    if (!mount) {
      mount = document.createElement('div');
      mount.setAttribute('data-sj-engraving-chip', '');
      field.appendChild(mount);
    }
    return mount;
  }

  function hideNativeToggle(field) {
    field.querySelectorAll('label, input[type="checkbox"]').forEach(function (el) {
      el.classList.add('sj-engraving-native');
    });
  }

  function hideNativeHelpers(panel) {
    if (!panel) return;
    panel.querySelectorAll('.tw\\:text-xs, [class*="text-xs"]').forEach(function (el) {
      if (el.hasAttribute('data-sj-engraving-meta')) return;
      var t = String(el.textContent || '').toLowerCase();
      if (
        t.includes('lines max') ||
        t.includes('characters per line') ||
        t.includes('lines used')
      ) {
        el.classList.add('sj-engraving-helper-native');
      }
    });
  }

  function ensureMetaLine(wrapper) {
    if (!wrapper) return null;
    var meta = wrapper.querySelector('[data-sj-engraving-meta]');
    if (!meta) {
      meta = document.createElement('div');
      meta.setAttribute('data-sj-engraving-meta', '');
      meta.className = 'sj-engraving-meta';
      var ta = wrapper.querySelector('textarea');
      if (ta) wrapper.insertBefore(meta, ta);
      else wrapper.appendChild(meta);
    }
    return meta;
  }

  function updateMetaLine(panel) {
    var wrapper = getInputWrapper(panel);
    var ta = getTextarea(panel);
    if (!wrapper || !ta) return;
    hideNativeHelpers(panel);
    var meta = ensureMetaLine(wrapper);
    if (!meta) return;
    var used = linesUsed(ta);
    meta.textContent = '3 lines — 6 characters — ' + used + ' / 3 lines used';
  }

  function chipStateKey(field, panel) {
    var cb = getCheckbox(field);
    if (!cb) return '';
    return (
      (cb.checked ? '1' : '0') +
      '|' +
      (cb.disabled ? '1' : '0') +
      '|' +
      priceLabel(field) +
      '|' +
      (waived ? 'free' : 'pay')
    );
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (ch) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[ch];
    });
  }

  function buildSubtitle(price) {
    if (waived && price) {
      return (
        '<span class="sj-engraving-was">' +
        escapeHtml(price) +
        '</span><span class="sj-engraving-free">Free</span>'
      );
    }
    if (waived) return '<span class="sj-engraving-free">Free</span>';
    if (price) return escapeHtml(price);
    return '';
  }

  function bytesToHex(buffer) {
    var bytes = new Uint8Array(buffer);
    var hex = '';
    for (var i = 0; i < bytes.length; i++) {
      hex += bytes[i].toString(16).padStart(2, '0');
    }
    return hex;
  }

  function hashesMatch(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    var diff = 0;
    for (var i = 0; i < a.length; i++) diff |= a.charCodeAt(i) ^ b.charCodeAt(i);
    return diff === 0;
  }

  function digestHex(text) {
    if (!window.crypto || !window.crypto.subtle) return Promise.resolve('');
    var data = new TextEncoder().encode(text);
    return window.crypto.subtle.digest('SHA-256', data).then(bytesToHex);
  }

  function pokePrice() {
    var w = hostWidget && hostWidget.__w;
    if (!w || typeof w.engraving === 'undefined') return;
    w.sjEngravingFree = waived ? 1 : 0;
    var text = w.engraving == null ? '' : String(w.engraving);
    w.engraving = text + '\u2060';
    w.engraving = text;
  }

  function refreshChips() {
    findEngravingFields().forEach(function (field) {
      field._sjEngravingKey = '';
      renderChip(field);
    });
  }

  function setWaived(next) {
    var changed = waived !== next;
    waived = next;
    if (changed) {
      pokePrice();
      refreshChips();
    }
    paintCodeStatus();
  }

  function paintCodeStatus() {
    document.querySelectorAll('[data-sj-engraving-code]').forEach(function (row) {
      var btn = row.querySelector('button');
      var status = row.querySelector('[data-sj-engraving-status]');
      if (btn) {
        btn.textContent = waived ? 'Applied' : 'Apply';
        btn.classList.toggle('is-applied', waived);
        btn.setAttribute('aria-pressed', waived ? 'true' : 'false');
      }
      if (!status) return;
      status.classList.remove('is-free', 'is-invalid');
      if (waived) {
        status.hidden = true;
        status.textContent = '';
      } else if (codeStatus === 'invalid') {
        status.hidden = false;
        status.classList.add('is-invalid');
        status.textContent = 'That code does not apply';
      } else {
        status.hidden = true;
        status.textContent = '';
      }
    });
  }

  function applyCode(input) {
    var raw = String((input && input.value) || '');
    var ticket = ++codeTicket;
    var normalized = raw.trim().toUpperCase();
    if (!normalized) {
      codeStatus = '';
      setWaived(false);
      return;
    }
    digestHex(normalized).then(function (hex) {
      if (ticket !== codeTicket) return;
      var ok = WAIVER_SHA256.some(function (expected) {
        return hashesMatch(hex, expected);
      });
      codeStatus = ok ? 'free' : 'invalid';
      setWaived(ok);
    });
  }

  function onCodeEdit() {
    codeStatus = '';
    if (waived) setWaived(false);
    else paintCodeStatus();
  }

  function ensureCodeRow(panel) {
    var wrapper = getInputWrapper(panel);
    if (!wrapper || wrapper.querySelector('[data-sj-engraving-code]')) return;
    var row = document.createElement('div');
    row.className = 'sj-engraving-code';
    row.setAttribute('data-sj-engraving-code', '');

    var line = document.createElement('div');
    line.className = 'sj-engraving-code__row';

    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'input';
    input.autocomplete = 'off';
    input.autocapitalize = 'characters';
    input.spellcheck = false;
    input.enterKeyHint = 'done';
    input.setAttribute('form', 'sj-engraving-code-offform');
    input.setAttribute('aria-label', 'Promo code');
    input.placeholder = 'Promo code';
    input.addEventListener('input', onCodeEdit);
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      applyCode(input);
    });

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sj-engraving-code__apply';
    btn.textContent = 'Apply';
    btn.setAttribute('form', 'sj-engraving-code-offform');
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      applyCode(input);
    });

    var status = document.createElement('p');
    status.className = 'sj-engraving-code__status';
    status.setAttribute('data-sj-engraving-status', '');
    status.hidden = true;

    line.appendChild(input);
    line.appendChild(btn);
    row.appendChild(line);
    row.appendChild(status);
    wrapper.appendChild(row);
    paintCodeStatus();
  }

  function renderChip(field) {
    var cb = getCheckbox(field);
    if (!cb) return;
    if (field._sjEngravingRendering) return;

    var panel = getPanel(field);
    var key = chipStateKey(field, panel);
    if (field._sjEngravingKey === key && field.querySelector('[data-sj-engraving-chip] button')) {
      field.classList.remove('sj-seal-size-absorbed');
      if (panel) {
        panel.classList.add(PANEL);
        panel.classList.toggle('is-open', Boolean(cb.checked));
        if (cb.checked) {
          updateMetaLine(panel);
          ensureCodeRow(panel);
        }
      }
      return;
    }

    field._sjEngravingRendering = true;
    try {
      hideNativeToggle(field);
      field.classList.add(HOST);
      field.classList.remove('sj-seal-size-absorbed');
      if (panel) {
        panel.classList.add(PANEL);
        panel.classList.toggle('is-open', Boolean(cb.checked));
        hideNativeHelpers(panel);
        if (cb.checked) updateMetaLine(panel);
      }

      var on = Boolean(cb.checked);
      var price = priceLabel(field);
      var mount = ensureMount(field);
      var subtitle = buildSubtitle(price);
      if (on && panel) ensureCodeRow(panel);

      var wrap = document.createElement('div');
      wrap.className = 'sj-seal-size-chips sj-engraving-chips';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', 'Engraving');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'sj-seal-size-chip sj-seal-size-chip--two-tone sj-engraving-chip';
      btn.classList.toggle('is-selected', on);
      btn.classList.toggle('is-on', on);
      btn.classList.toggle('is-free', on && waived);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        on
          ? 'Add engraving: On, ' + (waived ? 'Free' : price || 'on') + '. Tap to turn off.'
          : 'Add engraving: Off' + (price ? ', ' + price : '') + '. Tap to turn on.'
      );
      btn.innerHTML =
        '<span class="sj-seal-size-chip__text">' +
        '<span class="sj-seal-size-chip__title">Add Engraving</span>' +
        '<span class="sj-seal-size-chip__subtitle">' +
        subtitle +
        '</span>' +
        '</span>';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (cb.disabled) return;
        field._sjEngravingKey = '';
        cb.click();
        window.setTimeout(function () {
          renderChip(field);
          wireTextarea(field);
        }, 0);
      });

      wrap.appendChild(btn);
      mount.replaceChildren(wrap);
      field._sjEngravingKey = key;
      wireTextarea(field);
    } finally {
      field._sjEngravingRendering = false;
    }
  }

  function wireTextarea(field) {
    var panel = getPanel(field);
    var ta = getTextarea(panel);
    if (!ta || ta._sjEngravingInputBound) {
      if (panel) updateMetaLine(panel);
      return;
    }
    ta._sjEngravingInputBound = true;
    var sync = function () {
      updateMetaLine(panel);
    };
    ta.addEventListener('input', sync);
    ta.addEventListener('change', sync);
    updateMetaLine(panel);
  }

  function enhanceField(field) {
    if (!field || !getCheckbox(field)) return;

    if (field.getAttribute(READY) === '1') {
      renderChip(field);
      wireTextarea(field);
      return;
    }

    field.setAttribute(READY, '1');
    field.classList.remove('sj-seal-size-absorbed');
    renderChip(field);
    wireTextarea(field);

    var cb = getCheckbox(field);
    if (cb && !cb._sjEngravingChangeBound) {
      cb._sjEngravingChangeBound = true;
      cb.addEventListener('change', function () {
        field._sjEngravingKey = '';
        renderChip(field);
        wireTextarea(field);
      });
    }
  }

  function scan() {
    findEngravingFields().forEach(enhanceField);
  }

  B.bootOnWidget(function (widget) {
    hostWidget = widget;
    B.watchWidget(widget, scan);
  });
})();
